import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/trainers/2_2.jpg'
import _imports_1 from '@/assets/img/logo/logo_simple.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopupScroll = _resolveComponent("PopupScroll")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PopupScroll, {
      "tap-close": _ctx.onTapCloseButton,
      title: '施設Suggestion'
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "top-contents" }, [
          _createElementVNode("div", { class: "top-contents-img" }, [
            _createElementVNode("img", { src: _imports_0 })
          ]),
          _createElementVNode("div", { class: "top-contents-bottom" }, [
            _createElementVNode("div", { class: "name-wrap" }, [
              _createElementVNode("div", null, [
                _createElementVNode("p", { class: "des" }, "トレーナー"),
                _createElementVNode("p", { class: "name" }, [
                  _createTextVNode("T"),
                  _createElementVNode("span", { class: "text-gold" }, "O"),
                  _createTextVNode("RA")
                ]),
                _createElementVNode("p", { class: "name-kana" }, "トラ")
              ])
            ]),
            _createElementVNode("p", { class: "des2" }, [
              _createTextVNode(" 主に筋トレメインのトレーナーです。"),
              _createElementVNode("br"),
              _createTextVNode(" ボディメイクや食事など詳しく教えてくれます！ ")
            ]),
            _createElementVNode("div", { class: "class" }, [
              _createElementVNode("p", { class: "class-title" }, "担当クラス"),
              _createElementVNode("ul", { style: {"font-size":"1.4rem"} }, [
                _createElementVNode("li", null, " ボディメイククラス "),
                _createElementVNode("li", null, " ファットバーンクラス "),
                _createElementVNode("li", null, " リズムキック "),
                _createElementVNode("li", null, " CLUBリズムキック "),
                _createElementVNode("li", null, " エントリークラス "),
                _createElementVNode("li", null, " キック初級クラス "),
                _createElementVNode("li", null, " 筋膜リリースクラス ")
              ])
            ]),
            _createElementVNode("div", { class: "top-contents-bg" }, [
              _createElementVNode("img", { src: _imports_1 })
            ])
          ])
        ], -1),
        _createElementVNode("div", { class: "bottom-contents" }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", { class: "top-items-title" }, [
              _createElementVNode("h2", null, "Message"),
              _createElementVNode("p", null, "皆様に一言")
            ]),
            _createElementVNode("p", { class: "bottom-contents-text" }, [
              _createTextVNode(" 「格闘技からボディメイクまで運動を通して、"),
              _createElementVNode("br", { class: "sp-none" }),
              _createTextVNode("皆様のフィットネス生活を充実させていきます。"),
              _createElementVNode("br"),
              _createTextVNode(" 一緒に頑張りましょう！」 ")
            ])
          ]),
          _createElementVNode("div", { class: "bottom-contents-bg2" }, [
            _createTextVNode(" Make The Body"),
            _createElementVNode("br"),
            _createTextVNode(" You Dream About ")
          ])
        ], -1)
      ])),
      _: 1
    }, 8, ["tap-close"])
  ]))
}